import { TranslatePipe } from "@ngx-translate/core";
import { AngularSvgIconModule } from "angular-svg-icon";

import { ChangeDetectionStrategy, Component, computed, inject, signal } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogClose } from "@angular/material/dialog";

import { AirtScan } from "../../../apis/networkdashboard/graphql/graphql";

@Component({
  selector: "dialog-cert",
  templateUrl: "dialog-cert.html",
  styleUrl: "dialog-cert.scss",
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [TranslatePipe, AngularSvgIconModule, MatDialogClose],
})
export class DialogCert {
  protected data = inject<AirtScan>(MAT_DIALOG_DATA);
  private activeTab = signal("details");
  protected detailsActive = computed(() => this.activeTab() === "details");
  protected extraActive = computed(() => this.activeTab() === "extra");

  protected extraData = computed(() => {
    if (!this.data.extra) return [];
    const extra = this.data.extra as Record<string, unknown>;
    return Object.entries(extra)
      .filter(([, v]) => typeof v === "string" || Array.isArray(v))
      .map(([header, value]) => ({
        header,
        value: Array.isArray(value) ? value.join(", ") : (value as string),
      }));
  });

  protected changeTab(tab: string) {
    this.activeTab.set(tab);
  }
}
